import { useLocalObservable } from "mobx-react-lite";
import React, { createContext, useContext } from "react";

import InputVariableConfiguratorStore from "./input-variable-configurator-store";
import { Variable } from "./types";

const InputVariableConfiguratorStoreContext = createContext<
  InputVariableConfiguratorStore | undefined
>(undefined);

interface InputVariableConfiguratorStoreProviderProps {
  children: React.ReactNode;
  initialVariables?: Variable[];
  initialName?: string;
}

export const InputVariableConfiguratorStoreProvider = ({
  children,
  initialVariables = [],
  initialName = "",
}: InputVariableConfiguratorStoreProviderProps) => {
  const store = useLocalObservable(
    () => new InputVariableConfiguratorStore(initialVariables, initialName),
  );

  return (
    <InputVariableConfiguratorStoreContext.Provider value={store}>
      {children}
    </InputVariableConfiguratorStoreContext.Provider>
  );
};

export const useConfiguratorStore = () => {
  const context = useContext(InputVariableConfiguratorStoreContext);
  if (context === undefined) {
    throw new Error(
      "useConfiguratorStore must be used within InputVariableConfiguratorStoreProvider",
    );
  }
  return context;
};
